import initSearch from "@rei/search-input-suggestions";

// TODO SE-3006 - All this logic will be moved to SIS
const AUTOSUGGEST_SELECTOR = '[data-js=suggestion-box]';

/**
 * Initializes search - handles race conditions
 * In prod, the mounting point will almost always be available by the time
 * this code runs. However, during local dev, the page may still be loading
 * the page / global navigation header, so this allows for the fallback scenario
 * where page load has not yet occurred.
 *
 * @param {Object<string>} overrides: overrides for SIS selectors - typing:
 * export interface AutosuggestOverrides {
 *   gnavDataJsonSelector?: string | undefined;
 *   testConfigJsonSelector?: string | undefined;
 * }
 * @returns void
 */
const initSearchWithConfig = (overrides) => {
  /**
   * Checks if the mounting element is available in the DOM.
   * @returns {boolean}
   */
  const isReady = () => {
    const mountEl = document?.querySelector(AUTOSUGGEST_SELECTOR);
    return mountEl instanceof HTMLElement;
  };

  // if we still can't get the selector on DOM content loaded, we're on a
  // page where this shouldn't initialize
  const initialize = () => {
    if (!isReady(AUTOSUGGEST_SELECTOR)) return;
    initSearch(overrides);
  };

  // initialize now if mounting el is found, else wait for DOMContentLoaded
  if (isReady(AUTOSUGGEST_SELECTOR)) {
    initSearch(overrides);
  } else {
    window.addEventListener('DOMContentLoaded', initialize, { once: true });
  }
}

export default initSearchWithConfig;
